import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { InviteUsersPopup } from './InviteUsersPopup';

export const INVITE_USERS_POPUP = Symbol('INVITE_USERS');

export const useInviteUsersPopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(INVITE_USERS_POPUP, InviteUsersPopup);
  });

  return useCallback(() => {
    popups.openPopup(INVITE_USERS_POPUP, {
      onSubmit: () => {
        popups.closePopup(INVITE_USERS_POPUP);
      },
      onClose: () => {
        popups.closePopup(INVITE_USERS_POPUP);
      },
    });
  }, [popups]);
};
